// import useReversedFeatureFlag from '@/utils/hooks/useFeatureFlag';

// const FEATURE_FLAG_KEY = 'ADJUSTMENT_BALANCE_FEATURE_FLAG';
const useAdjustmentBalanceFeatureFlag = () => {
  // const isAvailable = useReversedFeatureFlag(FEATURE_FLAG_KEY, {
  //   dev: true,
  //   uat: true,
  // });
  return true;
};
export default useAdjustmentBalanceFeatureFlag;
